import { HttpService } from 'src/app/services/http/http.service';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Spinkit } from 'ng-http-loader';

@Component({
  selector: "app-superadminsidenav",
  templateUrl: "./superadminsidenav.component.html",
  styleUrls: ["./superadminsidenav.component.scss"],
})
export class SuperadminsidenavComponent implements OnInit {
  dashboardGreen = "../../../assets/img/dashboard.svg";
  dashboardGray = "../../../assets/img/dashboard-gray.svg";

  restoListGreen = "../../../assets/img/restolist-green.svg";
  restoListGray = "../../../assets/img/resto-list.svg";

  allergenGreen = "../../../assets/img/allergensDietarygreen.svg";
  allergenGray = "../../../assets/img/allergensDietary.svg";

  categoryGreen = "../../../assets/img/category-cuisine-green.svg";
  categoryGray = "../../../assets/img/category-cuisine.svg";

  settingGreen = "../../../assets/img/settingsGreen.jpg";
  settingGray = "../../../assets/img/settingsgray.png";

  emailTemplateGreen = "../../../assets/img/email-template-green.svg";
  emailTemplateGray = "../../../assets/img/email-template.svg";

  infoEventGreen = "../../../assets/img/regulatory-and-plan-green.svg";
  infoEventGray = "../../../assets/img/regulatory-and-plan.svg";

  d2RestoGreen = "../../../assets/img/restaurant-active.svg";
  d2RestoGray = "../../../assets/img/D2resraurants.svg";
  nutriLabelRestoGreen = "../../../assets/images/nutri_label-active.svg";
  nutriLabelRestoGray = "../../../assets/images/nutri_label-inactive.svg";
  weeklyTenGreen = "../../../assets/img/weekly-ten-active.svg";
  weeklyTenGray = "../../../assets/img/weekly-ten-inactive.svg";
  constructor(private router: Router, private httpSv : HttpService) {}
  public spinkit = Spinkit;
  greenColorText: boolean = false;
  expanded: boolean = true;
  src
  superAdminName:string
  superAdminEmail:string
  ngOnInit(): void {
    this.getAdminInfo()
  }

  goToDashboard() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/dashboard"]);
  }

  goToAllergens() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/allergensDietary"]);
  }

  goToCategory() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/categoryCuisines"]);
  }

  goToAccountSetting() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/accountSetting"]);
  }

  goToEmailTemplate() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/emailTemplate"]);
  }

  goToRegulatoryAndPlan() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/regulatoryAndPlan"]);
  }
  goToNutrilabelDish() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/nutri-label"]);
  }
  goToWeeklyTen(){
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/weeklyUpdate"]);
  }
  goToRestoList() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/restolist"]);
  }

  logout() {
    localStorage.clear();
    window.location.reload();
  }

  expandToggle() {
    this.expanded = !this.expanded;
  }
  getAdminInfo(){
    this.httpSv.getAdminInformation().subscribe(res=>{
      if(res['status']=='TRUE'){
        let temp = res['result'].data[0]
        this.src = temp.profile_image
        this.superAdminName = temp.f_name
        this.superAdminEmail = temp.email

      }
    })
  }
  goToD2RestoList() {
    this.expanded = !this.expanded;
    this.router.navigate(["/superadmin/d2restolist"]);
  }
}
